import { render, staticRenderFns } from "./AddView.vue?vue&type=template&id=5ebed9bc&scoped=true&"
import script from "./AddView.vue?vue&type=script&lang=ts&"
export * from "./AddView.vue?vue&type=script&lang=ts&"
import style0 from "./AddView.vue?vue&type=style&index=0&id=5ebed9bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebed9bc",
  null
  
)

export default component.exports